export const HAS_CHANGED_CAPTION = 'has_changed_caption'

const captionEventHandler = (jwPlayer: jwplayer.JWPlayer) => {
  jwPlayer.on('captionsChanged', () => {
    localStorage.setItem(HAS_CHANGED_CAPTION, 'true')
  })
}

export default captionEventHandler
